import React, { PureComponent } from "react";
 
import { BrowserRouter as Router} from "react-router-dom";
import {getRouter} from '../router';
import GlobalHeader from 'components/GlobalHeader'
import GlobalFooter from 'components/GlobalFooter'
import "./index.scss";

var nav = [
    {
        name: "优抚服务",
        url: "/preferential/preferential",
        // active: 1
    },
    {
        name: "优抚申请",
        url: "/preferential/application",
        // active: 1
    },
    {
        name: "优抚资讯",
        url: "/preferential/preferentialInfo"
    },
    {
        name: "优抚政策",
        url: "/preferential/preferentialPolicy"
    }
]


export default class Index extends PureComponent {
  render() {
    return (
        <div>
            <GlobalHeader nav={nav}  history={this.props.history}/>
             {getRouter()}
            <GlobalFooter />
        </div>
    );
  }
}
